import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "report-qc-notes-modal",
  "data-backdrop": "static",
  "data-keyboard": "true",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "report-qc-notes-modal-title",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-dialog modal-lg modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: "report-qc-notes-modal-title"
  }, "QC Notes"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "close",
    "data-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×")
  ])
], -1)
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = {
  class: "nav nav-tabs mb-3",
  role: "tablist"
}
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = {
  class: "tab-content mt-4",
  id: "qc-notes-tabs-content"
}
const _hoisted_10 = {
  class: "tab-pane fade show active",
  id: "qc-notes-warning",
  role: "tabpanel",
  "aria-labelledby": "qc-notes-tab-warning"
}
const _hoisted_11 = {
  class: "tab-pane fade",
  id: "qc-notes-critical",
  role: "tabpanel",
  "aria-labelledby": "qc-notes-tab-critical"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-outline-secondary mr-auto",
    "data-dismiss": "modal"
  }, " Cancel "),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-primary",
    "data-dismiss": "modal"
  }, " Ok ")
], -1)

import { ref, computed, inject } from 'vue';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportQCNotesModal',
  setup(__props) {

const store = useStore();

// Reactive State
const tab = ref('warning');

// Vuex Getters and Actions
const report = computed(() => store.getters['reports/current']);

const setReportDeep = async (payload: { path: string; data: any }): Promise<any> => {
  return store.dispatch('reports/setReportDeep', payload);
};

// Computed Properties with Getters and Setters
const warningNotes = computed({
  get: () => report.value.propertyDetails.qcWarningNotes,
  set: (data: string) => {
    setReportDeep({ path: 'propertyDetails.qcWarningNotes', data });
  }
});

const criticalNotes = computed({
  get: () => report.value.propertyDetails.qcCriticalNotes,
  set: (data: string) => {
    setReportDeep({ path: 'propertyDetails.qcCriticalNotes', data });
  }
});

// Methods
const setTab = (val: string) => {
  tab.value = val;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("ul", _hoisted_6, [
            _createElementVNode("li", _hoisted_7, [
              _createElementVNode("a", {
                class: "nav-link active",
                id: "qc-notes-tab-warning",
                "data-toggle": "tab",
                href: "#qc-notes-warning",
                role: "tab",
                "aria-controls": "new-room-add",
                "aria-selected": "true",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (setTab('warning')))
              }, " Warning Notes ")
            ]),
            _createElementVNode("li", _hoisted_8, [
              _createElementVNode("a", {
                class: "nav-link",
                id: "qc-notes-tab-critical",
                "data-toggle": "tab",
                href: "#qc-notes-critical",
                role: "tab",
                "aria-controls": "new-room-copy",
                "aria-selected": "false",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (setTab('critical')))
              }, " Critical Notes ")
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control",
                rows: "20",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((warningNotes).value = $event))
              }, null, 512), [
                [
                  _vModelText,
                  warningNotes.value,
                  void 0,
                  { lazy: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control",
                rows: "20",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((criticalNotes).value = $event))
              }, null, 512), [
                [
                  _vModelText,
                  criticalNotes.value,
                  void 0,
                  { lazy: true }
                ]
              ])
            ])
          ])
        ]),
        _hoisted_12
      ])
    ])
  ]))
}
}

})